import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Item, Row, Section } from 'components/ui/table/elements';
import PhoneInput from 'components/form/InputFields/MobianPhoneInput/PhoneInput';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import utils from 'helpers/utils';
import translate from 'components/hoc/translate';

const AccessMethodsSettings = (props) => {
    const {
        settings,
        translate,
    } = props;

    if (!settings) {
        return null;
    }

    return (
        <Section title={ translate('menu.sidebar.settings') }>
            {
                utils.map(settings, (config, field) => {
                    let component = RenderTextInputField;

                    if (field === 'phone') {
                        component = PhoneInput;
                    }

                    return (
                        <Row key={ `settings-${ field }` } >
                            <Item>
                                <Field
                                    component={ component }
                                    label={ translate(`resources.access_methods.fields.${ field }`) }
                                    fullWidth={ false }
                                    name={ `settings.${ field }` }
                                    validate={ config.validations }
                                />
                            </Item>
                        </Row>
                    );
                })
            }
        </Section>
    );
};

AccessMethodsSettings.propTypes = {
    settings: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(AccessMethodsSettings);


// WEBPACK FOOTER //
// ./src/pages/accessPoints/access-methods/settings/AccessMethodsSettings.js